// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fX","advertDetailParameterList__header":"c-p_fY","advertDetailParameterList__list":"c-p_fZ"};